import axios from 'axios';

// 配置
const request = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL || '/',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
    // withCredentials: true, // 跨域请求时是否需要使用凭证
    timeout: 30000, // 请求超时时间
})


// 请求拦截器
request.interceptors.request.use(
    config => {
        if (String(config.url || '').startsWith('/api/loan/')) {
            const originalData = config.data && typeof config.data === 'object' ? config.data : {};
            const code = String(originalData.code || window.localStorage.getItem('code') || '').trim();
            const accessToken = code ? (window.localStorage.getItem(`loan_access_token:${code}`) || '') : '';
            config.data = {
                ...originalData,
                ...(code ? { code } : {}),
                access_token: originalData.access_token || accessToken
            };
        }
        return config;
    },
    error => {
        return Promise.resolve(error);
    }
);
// 响应拦截器
request.interceptors.response.use(
    response => {
        const {
            data = {}
        } = response;
        return data;
    },
    err => {
        return Promise.reject(err);
    }
);

export default request;
